<template>
  <div>
    <header-component />
    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="flex justify-between items-center p-2">
          <div>
            <h3
              class="mb-0 w-full font-bold text-gray-800 text-md"
              style="text-transform: capitalize"
            >
              Service Requests List
            </h3>
          </div>
          <div class="flex items-center">
            <base-button size="sm" type="primary" @click="createServiceRequest"
              >Add New</base-button
            >
          </div>
        </div>

        <!-- Stats Buttons Section -->
        <div class="px-2 py-3 bg-gray-50 border-b border-gray-200">
          <div class="flex flex-wrap gap-2">
            <div
              v-if="
                !serviceRequestStats ||
                  !serviceRequestStats.status_breakdown ||
                  serviceRequestStats.status_breakdown.length === 0
              "
              class="text-sm text-gray-500"
            >
              Loading stats...
            </div>
            <button
              v-for="stat in serviceRequestStats.status_breakdown"
              :key="stat.status_id"
              @click="applyStatusFilter(stat.status_code)"
              class="flex flex-col justify-between items-center text-sm font-medium text-white rounded-md border-2 transition-colors duration-200 hover:opacity-80"
            >
              <span class="px-3 py-2 bg-blue-500">{{ stat.status_label }}</span>
              <span
                class="inline-flex justify-center items-center px-3 py-2 text-sm font-bold text-black rounded-md"
              >
                {{ stat.count }}
              </span>
            </button>
          </div>
        </div>

        <!-- Custom Tailwind CSS Table -->
        <div class="overflow-x-auto">
          <table
            class="min-w-full bg-white border border-gray-200"
            style="table-layout: fixed;"
          >
            <thead class="bg-gray-50">
              <tr>
                <th
                  class="px-1 py-2 w-20 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Number
                </th>
                <th
                  class="px-1 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Created At
                </th>
                <th
                  class="px-1 py-2 w-20 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Created By
                </th>
                <th
                  class="px-1 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                  style="width: 90px;"
                >
                  Customer
                </th>
                <th
                  class="px-1 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Vendor
                </th>
                <th
                  class="px-1 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Category
                </th>
                <th
                  class="px-1 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Status
                </th>
                <th
                  class="px-1 py-2 w-12 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Actions
                </th>
              </tr>
              <!-- Filter Row -->
              <tr class="bg-gray-100">
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.serviceRequestNumber"
                    type="text"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                    @keyup="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.createdAt"
                    type="date"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.createdBy"
                    type="text"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <div class="space-y-1">
                    <input
                      v-model="columnFilters.customerName"
                      type="text"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      @input="onColumnFilterChange"
                    />
                    <input
                      v-model="columnFilters.customerPhone"
                      type="text"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      @input="onColumnFilterChange"
                    />
                  </div>
                </th>
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.vendorName"
                    type="text"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <input
                    v-model="columnFilters.category"
                    type="text"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-1 py-2 border-b">
                  <select
                    v-model="columnFilters.status"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @change="onColumnFilterChange"
                  >
                    <option value="">All Status</option>
                    <option value="pending">Pending</option>
                    <option value="assigned">Assigned</option>
                    <option value="visited">Visited</option>
                    <option value="quotation_pending">Quotation Pending</option>
                    <option value="quotation_completed"
                      >Quotation Completed</option
                    >
                    <option value="work_in_progress">Work In Progress</option>
                    <option value="payment_pending">Payment Pending</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="billing">Billing</option>
                  </select>
                </th>
                <th class="px-1 py-2 border-b">
                  <!-- Clear filters button -->
                  <button
                    @click="clearColumnFilters"
                    class="px-2 py-1 w-full text-xs text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-1 focus:ring-red-500"
                  >
                    Clear
                  </button>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <!-- Data Rows -->
              <tr
                v-for="serviceRequest in tableData"
                :key="serviceRequest.serviceRequestId"
                class="hover:bg-gray-50"
              >
                <td class="px-1 py-2 text-xs whitespace-nowrap border-b">
                  <div class="space-y-1">
                    <div class="flex items-center space-x-1">
                      <span class="text-gray-900">{{
                        serviceRequest.serviceRequestNumber
                      }}</span>
                      <span
                        v-if="serviceRequest.branch === 'Baner'"
                        class="inline-flex px-1 py-0.5 text-xs font-semibold text-red-800 bg-red-100 rounded-full"
                      >
                        {{ serviceRequest.branch }}
                      </span>
                      <span
                        v-else
                        class="inline-flex px-1 py-0.5 text-xs font-semibold text-blue-800 bg-blue-100 rounded-full"
                      >
                        Aundh
                      </span>
                    </div>
                    <div
                      v-for="(line, idx) in getServiceRequestMetaLines(serviceRequest)"
                      :key="`${serviceRequest.serviceRequestId}-meta-${idx}`"
                      class="text-[11px] leading-4 text-gray-500"
                    >
                      {{ line }}
                    </div>
                  </div>
                </td>
                <td
                  class="px-1 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ formatDate(serviceRequest.date) }}
                </td>
                <td class="px-1 py-2 text-xs text-gray-900 border-b">
                  <div class="w-full truncate" :title="getCreatedByDisplay(serviceRequest)">
                    {{ getCreatedByDisplay(serviceRequest) }}
                  </div>
                </td>
                <td class="px-1 py-2 text-xs text-gray-900 border-b">
                  <div
                    class="w-full truncate"
                    :title="
                      serviceRequest.users.firstName +
                        ' ' +
                        serviceRequest.users.lastName
                    "
                  >
                    {{ serviceRequest.users.firstName }}
                    {{ serviceRequest.users.lastName }}
                  </div>
                </td>
                <td class="px-1 py-2 text-xs text-gray-900 border-b">
                  <div
                    class="w-full truncate"
                    v-if="serviceRequest.vendor"
                    :title="
                      serviceRequest.vendor.firstName +
                        ' ' +
                        serviceRequest.vendor.lastName
                    "
                  >
                    {{ serviceRequest.vendor.firstName }}
                    {{ serviceRequest.vendor.lastName }}
                  </div>
                  <span v-else class="text-gray-500">--</span>
                </td>
                <td class="px-1 py-2 text-xs text-gray-900 border-b">
                  <div
                    class="w-full truncate"
                    v-if="serviceRequest.vendor"
                    :title="serviceRequest.category"
                  >
                    {{ serviceRequest.category }}
                  </div>
                  <span v-else class="text-gray-500">--</span>
                </td>
                <td class="px-1 py-2 text-xs whitespace-nowrap border-b">
                  <span
                    v-if="serviceRequest.status"
                    class="inline-flex px-2 py-1 text-xs font-semibold rounded-md"
                    :class="{
                      'bg-red-800 text-white':
                        serviceRequest.status.code === 'pending',
                      'bg-blue-500 text-white':
                        serviceRequest.status.code === 'assigned',
                      'bg-yellow-300 text-black':
                        serviceRequest.status.code === 'visited',
                      'bg-pink-100 text-pink-800':
                        serviceRequest.status.code === 'quotation_pending',
                      'bg-green-100 text-green-800':
                        serviceRequest.status.code === 'quotation_completed',
                      'bg-yellow-500 text-black':
                        serviceRequest.status.code === 'work_in_progress',
                      'bg-red-100 text-red-800':
                        serviceRequest.status.code === 'payment_pending',
                      'bg-green-100 text-green-800':
                        serviceRequest.status.code === 'completed',
                      'bg-gray-100 text-gray-800':
                        serviceRequest.status.code === 'cancelled',
                      'bg-blue-100 text-blue-800':
                        serviceRequest.status.code === 'billing'
                    }"
                  >
                    {{ serviceRequest.status.label }}
                  </span>
                </td>
                <td
                  class="px-1 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  <div class="inline-block relative text-left">
                    <button
                      @click="toggleDropdown(serviceRequest.serviceRequestId)"
                      class="inline-flex justify-center items-center w-6 h-6 text-gray-600 rounded-full hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      <svg
                        class="w-3 h-3"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                        />
                      </svg>
                    </button>

                    <!-- Dropdown Menu -->
                    <div
                      v-if="activeDropdown === serviceRequest.serviceRequestId"
                      class="absolute right-0 z-10 mt-1 w-36 bg-white rounded-md border border-gray-200 ring-1 ring-black ring-opacity-5 shadow-lg origin-top-right"
                    >
                      <div class="py-1">
                        <button
                          @click="handleAction(serviceRequest, 'timeline')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Timeline
                        </button>
                        <button
                          v-if="serviceRequest.status.code != 'completed'"
                          @click="handleAction(serviceRequest, 'edit')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Edit
                        </button>
                        <button
                          v-if="serviceRequest.vendorId"
                          @click="handleAction(serviceRequest, 'flow')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Flow
                        </button>
                        <button
                          v-if="serviceRequest.status.code != 'completed'"
                          @click="handleAction(serviceRequest, 'advance')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Make Payment
                        </button>
                        <button
                          v-if="
                            serviceRequest.status.code === 'pending' ||
                              serviceRequest.status.code === 'assigned' || 
                              serviceRequest.status.code === 'visited' ||
                              serviceRequest.status.code === 'quotation_pending' ||
                              serviceRequest.status.code === 'quotation_completed' 
                            
                          "
                          @click="handleAction(serviceRequest, 'cancelRequest')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Cancel Request
                        </button>
                        <!-- <button
                        
                          @click="handleAction(serviceRequest, 'putOnHold')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Put On Hold
                        </button> -->
                        <button
                          v-if="serviceRequest.vendorInvoice"
                          @click="handleAction(serviceRequest, 'vendorInvoice')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Show Vendor Invoice
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- Empty State -->
              <tr v-if="!tableData || tableData.length === 0">
                <td
                  colspan="8"
                  class="px-2 py-4 text-xs text-center text-gray-500 border-b"
                >
                  <div v-if="loading" class="table-loader">Loading...</div>
                  <div v-else>No Data</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card-footer">
          <div
            v-if="meta"
            slot="footer"
            class="flex-wrap col-12 d-flex justify-content-center justify-content-sm-between"
          >
            <div class>
              <p class="card-category">
                Showing {{ meta.from + 1 }} to {{ meta.to }} of
                {{ meta.total }} entries
                <span v-if="selectedRows.length"
                  >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span
                >
              </p>
            </div>
            <pagination :meta="meta" @paginate="setPagination" />
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="addServiceRequest" title="Add Service Request">
        <add-serviceRequest @close="addServiceRequest = false" />
      </el-dialog>
      <el-dialog :visible.sync="showAdvance" title="Add Payment">
        <add-advance
          :service-request-id="serviceRequestId"
          @close="showAdvance = false"
        />
      </el-dialog>
      <el-dialog
        :visible.sync="cancelServiceRequest"
        title="Reason"
        width="40%"
      >
        <cancel-serviceRequest @close="cancelServiceRequest = false" />
      </el-dialog>
      <el-dialog
        @open="onDialogOpen"
        @close="onDialogClose"
        :visible.sync="showVendorInvoiceModal"
        title="Vendor Invoice"
        width="50%"
      >
        <vendor-invoice ref="vendorInvoice" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button,
  Tooltip
} from "element-ui";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import AddServiceRequest from "./AddServiceRequest";
import { format } from "date-fns";
import headerComponent from "../Components/HeaderComponent";
import pagination from "@/components/AmsaPagination";
import AddAdvance from "./AddAdvance.vue";
import CancelServiceRequest from "./CancelServiceRequest";
import VendorInvoiceDesign from "./VendorInvoiceDesign.vue";
export default {
  filters: {
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    pagination,
    [Tooltip.name]: Tooltip,
    "add-serviceRequest": AddServiceRequest,
    "header-component": headerComponent,
    "add-advance": AddAdvance,
    "cancel-serviceRequest": CancelServiceRequest,
    "vendor-invoice": VendorInvoiceDesign
  },
  data: () => {
    return {
      addServiceRequest: false,
      cancelServiceRequest: false,
      filters: [],
      loading: false,
      pageSize: 50,
      selectedRows: [],
      searchOptions: {
        options: ["On Site", "In House"],
        dateRange: [new Date(), new Date()]
      },
      showAdvance: false,
      serviceRequestId: null,
      showVendorInvoiceModal: false,
      vendorInvoiceData: null,
      activeDropdown: null, // Track which dropdown is open
      columnFilters: {
        serviceRequestNumber: "",
        createdAt: "",
        createdBy: "",
        customerName: "",
        customerPhone: "",
        vendorName: "",
        category: "",
        status: ""
      },
      filterTimeout: null,
      requestSequence: 0, // Track request sequence to ignore stale responses
      lastValidRequestId: 0, // Track the requestId of the currently displayed data
      cachedServiceRequestList: null // Cache the data to prevent stale updates
    };
  },
  computed: {
    ...mapGetters({
      serviceRequest: "serviceRequest/getServiceRequest",
      serviceRequestList: "serviceRequest/getServiceRequestList",
      statusList: "status/getStatusList",
      serviceRequestStats: "serviceRequest/getServiceRequestStats"
    }),
    ...mapState("serviceRequest", ["serviceRequest"]),
    tableData() {
      // For column filter requests, use cached data to prevent stale updates
      // For other requests (pagination, other filters), use store data directly
      if (this.lastValidRequestId > 0 && this.cachedServiceRequestList && this.cachedServiceRequestList.rows) {
        return this.cachedServiceRequestList.rows;
      }
      return this.serviceRequestList.rows || [];
    },
    meta() {
      // For column filter requests, use cached data to prevent stale updates
      // For other requests (pagination, other filters), use store data directly
      if (this.lastValidRequestId > 0 && this.cachedServiceRequestList && this.cachedServiceRequestList.meta) {
        return this.cachedServiceRequestList.meta;
      }
      return this.serviceRequestList.meta || {};
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: function(value, oldValue) {
        this.restructureFilters(value);
      }
    }
  },

  mounted() {
    this.fetchNestedServiceCategories();
    this.getStatusList();
    this.getServiceRequestStats(); // Fetch stats on mount
    const data = window.localStorage.getItem("serviceRequestFilters");
    const parsedData = JSON.parse(data);
    if (data != null && parsedData.length != 0) {
      if (parsedData.length > 1) {
        const list = parsedData;
        this.filters.push(...list);
      } else {
        this.filters.push(...parsedData);
      }
    } else {
      this.paginate();
    }
    // Add click outside listener to close dropdowns
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove click outside listener
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    ...mapActions({
      getServiceRequestList: "serviceRequest/getServiceRequestList",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      getServiceRequestTransactions:
        "serviceRequestTransaction/getServiceRequestTransactions",
      getNestedServiceCategories: "serviceCategory/getNestedServiceCategories",
      updateServiceRequest: "serviceRequest/updateServiceRequest",
      getStatusList: "status/getStatusList",
      getServiceRequestLabors: "serviceRequestLabor/getServiceRequestLabors",
      getServiceRequestStats: "serviceRequest/getServiceRequestStats"
    }),
    ...mapMutations({
      setServiceRequest: "serviceRequest/setServiceRequest",
      resetServiceRequest: "serviceRequest/resetServiceRequest",
      resetServiceRequestTransaction:
        "serviceRequestTransaction/resetServiceRequestTransaction",
      setVendorInvoiceData: "vendor/setVendorInvoiceData"
    }),
    handleAction(serviceRequest, command) {
      if (command === "edit") {
        this.fetchServiceRequest(serviceRequest.serviceRequestId).then(res => {
          this.setServiceRequest(res);
          this.$router.push(
            `/serviceRequests/edit/${serviceRequest.serviceRequestId}`
          );
        });
      } else if (command === "timeline") {
        this.$router.push({
          path: `/serviceRequests/timeline/${serviceRequest.serviceRequestId}`
        });
      } else if (command === "flow") {
        this.fetchServiceRequest(serviceRequest.serviceRequestId).then(
          response => {
            this.$router.push({
              path: `/serviceRequests/flow/${serviceRequest.serviceRequestId}`
            });
          }
        );
      } else if (command === "advance") {
        this.serviceRequestId = serviceRequest.serviceRequestId;
        this.getServiceRequestTransactions(serviceRequest.serviceRequestId);
        this.resetServiceRequestTransaction();
        this.showAdvance = true;
      } else if (command === "cancelRequest") {
        this.fetchServiceRequest(serviceRequest.serviceRequestId).then(res => {
          this.setServiceRequest(res);
          this.cancelServiceRequest = true;
        });
      } else if (command === "vendorInvoice") {
        this.serviceRequestId = serviceRequest.serviceRequestId;
        this.handleShowVendorInvoice(serviceRequest);
      } else if (command === "putOnHold") {
        this.fetchServiceRequest(serviceRequest.serviceRequestId).then(res => {
          this.setServiceRequest(res);
          this.putOnHold = true;
        });
      }
      this.activeDropdown = null; // Close dropdown after action
    },

    createServiceRequest() {
      this.resetServiceRequest();
      this.$router.push({ path: "/serviceRequests/add" });
    },
    setPagination(data) {
      this.pageSize = data.perPage;
      this.restructureFilters(this.filters, data.page);
    },
    paginate(page = 1, filters = {}, requestId = null) {
      if (filters.type) {
        if (filters.type.toLowerCase() === "on site") {
          filters.type = true;
        } else if (filters.type.toLowerCase() === "in house") {
          filters.type = false;
        }
      }
      let query = {
        page,
        perPage: this.pageSize,
        ...filters
      };
      this.getServiceRequestStats(filters);
      this.loading = true;
      const currentRequestId = requestId !== null ? requestId : this.requestSequence;
      
      // If this is not a column filter request, clear the cache so we use store data
      if (requestId === null) {
        this.cachedServiceRequestList = null;
        this.lastValidRequestId = 0;
      }
      
      this.getServiceRequestList(query).then(data => {
        // Only update UI if this response matches the latest request
        // This prevents stale responses from overwriting newer results
        // If requestId is null (from other sources), always process it
        // If requestId is set, only process if it matches the current requestSequence
        if (requestId === null || currentRequestId === this.requestSequence) {
          // For column filter requests, cache the data to prevent stale updates
          if (requestId !== null) {
            this.cachedServiceRequestList = data;
            this.lastValidRequestId = currentRequestId;
          }
          this.loading = false;
        }
        // If this is a stale response, ignore it - don't update loading or cache
      }).catch(err => {
        // Only update loading state if this is still the latest request
        if (requestId === null || currentRequestId === this.requestSequence) {
          this.loading = false;
        }
      });
    },
    async fetchNestedServiceCategories() {
      const options = await this.getNestedServiceCategories();
    },
    applyFilters(filters) {
      if (filters.length > 1) {
        this.filters.push(...filters);
      } else {
        this.filters.push(filters);
      }
      window.localStorage.setItem(
        "serviceRequestFilters",
        JSON.stringify(this.filters)
      );
      this.getServiceRequestStats();
    },
    removeFilter(tagIndex) {
      if (
        this.filters[tagIndex].field === "attribute" ||
        this.filters[tagIndex].field === "value"
      ) {
        const selectedItem = this.filters.find(
          (_, index) => index === tagIndex
        );
        const item = this.filters.find(i => i.type === selectedItem.type);
        this.filters.splice(tagIndex, 1);
        const index = this.filters.indexOf(item);
        this.filters.splice(index, 1);
      } else {
        this.filters.splice(tagIndex, 1);
      }
      if (this.filters.length > 0) {
        window.localStorage.setItem(
          "serviceRequestFilters",
          JSON.stringify(this.filters)
        );
      } else {
        window.localStorage.removeItem("serviceRequestFilters");
      }
    },
    restructureFilters(value, page = 1, requestId = null) {
      const filtered = {};
      value.forEach(i => {
        if (i.field === "createdAt") {
          filtered.fromDate = i.value[0];
          filtered.toDate = i.value[1];
        } else {
          filtered[i.field] = i.value;
        }
      });
      if (Object.entries(filtered).length > 0) {
        this.paginate(page, filtered, requestId);
      } else {
        this.paginate(page, {}, requestId);
      }
    },
    formatDate(date) {
      return format(date, "Do MMM YY");
    },
    getCreatedByDisplay(serviceRequest) {
      const createdBy = serviceRequest.createdBy || serviceRequest.created_by;
      if (!createdBy || typeof createdBy !== "object") return "-";
      const firstName =
        createdBy.firstName || createdBy.first_name || createdBy.name || "";
      const lastName = createdBy.lastName || createdBy.last_name || "";
      const fullName = `${firstName} ${lastName}`.trim();
      return fullName || "-";
    },
    getServiceRequestMetaLines(serviceRequest) {
      return [`Created by: ${this.getCreatedByDisplay(serviceRequest)}`];
    },
    toggleDropdown(serviceRequestId) {
      this.activeDropdown =
        this.activeDropdown === serviceRequestId ? null : serviceRequestId;
    },
    handleClickOutside(event) {
      // Close dropdown if clicking outside
      if (!event.target.closest(".relative")) {
        this.activeDropdown = null;
      }
    },
    handleShowVendorInvoice(serviceRequest) {
      this.getServiceRequestLabors(this.serviceRequestId).then(res => {
        const vendor = serviceRequest.vendor || {};
        const vendorFirmName = (
          vendor.firmName ||
          vendor.firm_name ||
          ""
        )
          .toString()
          .trim();
        const vendorDisplayName =
          vendorFirmName ||
          `${vendor.firstName || ""} ${vendor.lastName || ""}`.trim() ||
          "Vendor";
        this.vendorInvoiceData = {
          labors: res,
          externalGoodsMeta: serviceRequest.externalGoodsMeta || [],
          externalGoodsTotal: serviceRequest.externalGoodsTotal || 0,
          laborDiscount: serviceRequest.laborDiscount || 0,
          vendor: {
            name: vendorDisplayName,
            firmName: vendorFirmName,
            phone: vendor.phone
          },
          customer: {
            name:
              serviceRequest.users.firstName +
              " " +
              serviceRequest.users.lastName,
            phone: serviceRequest.users.phone
          },
          invoiceNumber: serviceRequest.vendorInvoice,
          invoiceDate: serviceRequest.invoiceDate,
          serviceRequestId: this.serviceRequestId,
          serviceRequestNumber: serviceRequest.serviceRequestNumber || "",
          userId: serviceRequest.userId
        };

        this.showVendorInvoiceModal = true;
        this.setVendorInvoiceData(this.vendorInvoiceData);
      });
    },
    onDialogOpen() {
      if (this.$refs && this.$refs.vendorInvoice) {
        this.$refs.vendorInvoice.fetchData(); // Call the fetch function in the child
      }
    },
    onDialogClose() {
      if (this.$refs && this.$refs.vendorInvoice) {
        this.$refs.vendorInvoice.resetProperty();
      }
    },
    applyStatusFilter(status) {
      // Keep all existing column filters and only update the status filter.
      this.columnFilters.status = status;
      this.onColumnFilterChange();
    },

    onColumnFilterChange() {
      // Debounce the filter to avoid too many API calls
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        // Increment request sequence to track this as the latest request
        this.requestSequence++;
        // Capture current column filter values and request sequence at the time of execution
        const currentColumnFilters = { ...this.columnFilters };
        const requestId = this.requestSequence;
        this.applyColumnFilters(currentColumnFilters, requestId);
      }, 300);
    },

    applyColumnFilters(columnFiltersToApply = null, requestId = null) {
      // Use provided filters or current columnFilters
      const filtersToUse = columnFiltersToApply || this.columnFilters;
      
      // Define which fields are column filters (to identify and replace them)
      const columnFilterFields = [
        "number",
        "createdAt",
        "createdBy",
        "customer",
        "customerPhone",
        "vendor",
        "category",
        "status"
      ];

      // Start with existing filters, but exclude column filters
      const existingFilters = this.filters.filter(
        filter => !columnFilterFields.includes(filter.field)
      );

      const newColumnFilters = [];

      // Convert column filters to API filter format
      if (filtersToUse.serviceRequestNumber) {
        newColumnFilters.push({
          field: "number",
          label: filtersToUse.serviceRequestNumber,
          value: filtersToUse.serviceRequestNumber
        });
      }

      if (filtersToUse.createdAt) {
        // For single date, create a range with same date
        newColumnFilters.push({
          field: "createdAt",
          label: filtersToUse.createdAt,
          value: [filtersToUse.createdAt, filtersToUse.createdAt]
        });
      }

      if (filtersToUse.createdBy) {
        newColumnFilters.push({
          field: "createdBy",
          label: filtersToUse.createdBy,
          value: filtersToUse.createdBy
        });
      }

      if (filtersToUse.customerName) {
        newColumnFilters.push({
          field: "customer",
          label: `Name: ${filtersToUse.customerName}`,
          value: filtersToUse.customerName
        });
      }

      if (filtersToUse.customerPhone) {
        newColumnFilters.push({
          field: "customerPhone",
          label: `Phone: ${filtersToUse.customerPhone}`,
          value: filtersToUse.customerPhone
        });
      }

      if (filtersToUse.vendorName) {
        newColumnFilters.push({
          field: "vendor",
          label: filtersToUse.vendorName,
          value: filtersToUse.vendorName
        });
      }

      if (filtersToUse.category) {
        newColumnFilters.push({
          field: "category",
          label: filtersToUse.category,
          value: filtersToUse.category
        });
      }

      if (filtersToUse.status) {
        newColumnFilters.push({
          field: "status",
          label: filtersToUse.status,
          value: filtersToUse.status
        });
      }

      // Merge existing non-column filters with new column filters
      this.filters = [...existingFilters, ...newColumnFilters];
      
      // Update localStorage
      if (this.filters.length > 0) {
        window.localStorage.setItem(
          "serviceRequestFilters",
          JSON.stringify(this.filters)
        );
      } else {
        window.localStorage.removeItem("serviceRequestFilters");
      }
      
      this.restructureFilters(this.filters, 1, requestId);
    },

    clearColumnFilters() {
      // Define which fields are column filters
      const columnFilterFields = [
        "number",
        "createdAt",
        "createdBy",
        "customer",
        "customerPhone",
        "vendor",
        "category",
        "status"
      ];

      // Clear column filter inputs
      this.columnFilters = {
        serviceRequestNumber: "",
        createdAt: "",
        createdBy: "",
        customerName: "",
        customerPhone: "",
        vendorName: "",
        category: "",
        status: ""
      };

      // Remove only column filters, keep other filters
      this.filters = this.filters.filter(
        filter => !columnFilterFields.includes(filter.field)
      );

      // Update localStorage
      if (this.filters.length > 0) {
        window.localStorage.setItem(
          "serviceRequestFilters",
          JSON.stringify(this.filters)
        );
      } else {
        window.localStorage.removeItem("serviceRequestFilters");
      }

      this.paginate(1);
    }
  }
};
</script>
<style>
.visited-status {
  background-color: #cdd002;
  border-color: #cdd002;
  color: #fff;
}
.cancelled-status {
  background-color: #b0ccb3;
  border-color: #b0ccb3;
  color: #fff;
}
.payment-pending-status {
  background-color: #b92f36eb;
  border-color: #b92f36eb;
  color: #fff;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.quotation-pending-status {
  background-color: #e57585;
  border-color: #e57585;
  color: #fff;
}
.quotation-completed-status {
  background-color: #679f68;
  border-color: #679f68;
  color: #fff;
}
.work-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
.billing-status {
  background-color: #1a4ddc;
  border-color: #1a4ddc;
  color: #fff;
}
.assign-status {
  background-color: #60c8be;
  border-color: #60c8be;
  color: #fff;
}
</style>
